import React, {Component} from 'react';
import {
    Dimensions,
    StyleSheet,
    Text,
    TouchableOpacity,
    View, Image
} from 'react-native';
import HMTextView from "../../../../../customviews/HMTextView";
import Colors, {colorPrimary} from "../../../../../tools/Colors";
import {moderateScale} from "../../../../../tools/Scaling";
import {serviceActionAddCart, serviceActionPriceAll, serviceActionSubCart} from "../../../splash/action/ActionSplashGetAllData";
import connect from "react-redux/es/connect/connect";
import HMImageView from "../../../../../customviews/HMImageView";


class DetailsAdapter extends Component {
    render() {
        const {item, index} = this.props;
        // let discount_food = parseInt(item.price - (item.price * (item.discount / 100)));

        return (


            <View style={{alignItems: 'center', flex: 1}}>

                <View
                    style={{
                        alignSelf: 'center',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: moderateScale(15),
                        width: "100%",
                        height: moderateScale(180),
                        //marginTop: moderateScale(4),
                    }}
                >


                    <HMImageView  uriComplete={item.image}
                                  styleText={{marginTop: moderateScale(10)}}
                                  styleShadoBackground={{borderRadius: moderateScale(7)}}
                    />


                </View>
                <View style={{width: moderateScale(8)}}/>
                <HMTextView text={item.title} style={{
                    // alignSelf: 'center',
                    //  marginRight: moderateScale(6),
                    // margin: moderateScale(6),
                    //  textAlign: 'center',
                    color: Colors.colorDark,
                    fontSize: moderateScale(14),
                    marginHorizontal: moderateScale(6)
                }}/>


            </View>


        );
    }
}

const mapStateToProps = (state) => {

    return {
        CartList: state.reducerSplashGetAllData.CartList,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        callServiceAddCart: (data) => dispatch(serviceActionAddCart(data)),
        callServiceSubCart: (data) => dispatch(serviceActionSubCart(data)),
        callServicePriceAll: () => dispatch(serviceActionPriceAll()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsAdapter);
const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        flex: 1,
        justifyContent: "flex-end",
        flexDirection: "row",
        marginEnd: moderateScale(10),
        paddingVertical: moderateScale(7),
        marginVertical: moderateScale(2.5),
        borderRadius: moderateScale(5),
        backgroundColor: Colors.light

    },
    buttons: {
        marginHorizontal: moderateScale(7),
        alignItems: "center",
        justifyContent: "center",
    }
});
